import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDesign } from '../context/DesignContext';
import { useOrder } from '../context/OrderContext';
import { EditorForm } from '../components/editor/EditorForm';
import { QrCodeSelector } from '../components/editor/QrCodeSelector';
import { ValidationPanel } from '../components/editor/ValidationPanel';
import { CardCanvas } from '../components/editor/CardCanvas';
import { api } from '../lib/api';
import { validateDesign } from '../lib/validation';
import { generateCardPdf, urlToBytes } from '../lib/pdf';
import { buildQrValue, generateQrDataUrl } from '../lib/qr';

export function EditorPage() {
  const design = useDesign();
  const { addItem } = useOrder();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGenerate = async () => {
    const result = validateDesign(design);
    if (!result.valid) {
      setError('Bitte behebe zuerst die Validierungsfehler.');
      return;
    }
    if (!design.productUid) {
      setError('Kein Produkt ausgewählt. Bitte gehe zurück und wähle ein Format.');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const qrBytes = design.qrCode
        ? await urlToBytes(await generateQrDataUrl(buildQrValue(design.qrCode.type, design.qrCode.value)))
        : null;
      const logoBytes = design.logoUrl ? await urlToBytes(design.logoUrl) : null;

      const pdfBytes = await generateCardPdf(design, { logoBytes, qrBytes });
      const file = new File([pdfBytes as unknown as BlobPart], 'visitenkarte.pdf', { type: 'application/pdf' });

      const res = await api.uploadFile(file);
      addItem({ productUid: design.productUid, quantity: 1, fileKey: res.key, fileUrl: res.publicUrl });
      navigate('/checkout');
    } catch (e: any) {
      setError(e.message || 'PDF-Erzeugung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Visitenkarte gestalten</h2>
      <p className="text-muted" style={{ marginBottom: '1.5rem' }}>
        Passe Texte, Farben, Logo und QR-Code an. Rechts siehst du die Live-Vorschau im Maßstab 85 × 55 mm.
      </p>

      <div className="grid grid-2" style={{ gap: '2rem', alignItems: 'start' }}>
        <div className="card">
          <h3>Inhalt</h3>
          <EditorForm />
        </div>

        <div>
          <div className="card" style={{ display: 'flex', justifyContent: 'center' }}>
            <CardCanvas design={design} />
          </div>

          <div className="card">
            <h3>QR-Code</h3>
            <QrCodeSelector />
          </div>

          <div className="card">
            <h3>Validierung</h3>
            <ValidationPanel />
          </div>

          <button className="btn btn-primary" onClick={handleGenerate} disabled={loading} style={{ width: '100%' }}>
            {loading ? '⏳ Erzeuge PDF…' : 'PDF erzeugen & weiter'}
          </button>
          {error && <p className="error" style={{ marginTop: '0.75rem' }}>{error}</p>}
        </div>
      </div>
    </div>
  );
}
